import io from 'socket.io-client';
import { API_BASE_URL } from '../config/api';

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.messageListeners = new Set();
    this.statusListeners = new Set();
  }

  connect(userData) {
    if (this.socket) {
      this.disconnect();
    }

    // Extract base URL without /api suffix for socket connection
    const socketURL = API_BASE_URL.replace('/api', '');
    
    this.socket = io(socketURL, {
      transports: ['websocket', 'polling'],
      autoConnect: true
    });

    this.socket.on('connect', () => {
      console.log('Connected to server');
      this.isConnected = true;
      
      // Join with user data
      this.socket.emit('join', userData);
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from server');
      this.isConnected = false;
    });

    // Listen for new messages
    this.socket.on('new_message', (message) => {
      console.log('New message received:', message);
      this.messageListeners.forEach(listener => listener(message));
    });

    // Listen for message sent confirmation
    this.socket.on('message_sent', (message) => {
      console.log('Message sent confirmation:', message);
      this.messageListeners.forEach(listener => listener(message, true));
    });

    // Listen for user online status
    this.socket.on('user_online', (data) => {
      console.log('User came online:', data);
      this.statusListeners.forEach(listener => listener(data.user_id, true));
    });

    // Listen for user offline status
    this.socket.on('user_offline', (data) => {
      console.log('User went offline:', data);
      this.statusListeners.forEach(listener => listener(data.user_id, false));
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  sendMessage(messageData) {
    if (this.socket && this.isConnected) {
      this.socket.emit('send_message', messageData);
    }
  }

  // Add listener for new messages
  addMessageListener(callback) {
    this.messageListeners.add(callback);
    
    // Return cleanup function
    return () => {
      this.messageListeners.delete(callback);
    };
  }

  // Add listener for online status changes
  addStatusListener(callback) {
    this.statusListeners.add(callback);
    
    // Return cleanup function
    return () => {
      this.statusListeners.delete(callback);
    };
  }

  // Remove all listeners
  removeAllListeners() {
    this.messageListeners.clear();
    this.statusListeners.clear();
  }

  getConnectionStatus() {
    return this.isConnected;
  }

  // Expose socket instance for custom event listeners
  getSocket() {
    return this.socket;
  }
}

// Create singleton instance
const socketService = new SocketService();

export default socketService;
